import { ProductionsService } from "./../../../services/documents/ProductionsService";
import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ProductionsDetail } from "../../../components/Pages/Documents/Productions/ProductionsDetail";
import { CreateProductionsDto } from "../../../dtos/documents/Productions/CreateProductionsDto";
import { NFLookupProductions } from "../../../components/Shared/NewForms/NFLookupProductions";
import ProductionsList from "../../../components/Pages/Documents/Productions/ProductionsList";

export const Productions: IAppEntity = {
  entityType: "document",
  title: "Productions",
  pluralTitle: "Productions",
  apiUrl: "Productions",
  apiEnum: ReferenceTypes.DocumentEmployeeDismissal,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ProductionsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ProductionsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupProductions, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ProductionsService("Productions"),
  getEmptyModel: () => {
    const model: CreateProductionsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      productionMaterialsAndWorks: [],
      productionManufacturedProducts: [],
    };
    return model;
  },
};
